const state = {
    travelOptionTypes: window.APP.travelOptionTypes,

    discountTypes: {
        percent: window.APP.discountTypes.percent,
    },

    officeEmail: window.APP.officeEmail,

    eurToPln: window.APP.eurToPln,

    addressTypes: {
        pickup: 'pickup',
        destination: 'destination',
        return_pickup: 'return_pickup',
        return_destination: 'return_destination',
    },

    defaultCurrencyCode: 'PLN',

    settings: window.APP.settings,

};

const getters = {
    travelOptionTypes: (state) => {
        return state.travelOptionTypes;
    },

    findTravelOptionTypeLabel: (state) => (type) => {
        return state.travelOptionTypes[type];
    },

    discountTypePercent: (state) => {
        return state.discountTypes.percent;
    },

    officeEmail: (state) => {
        return state.officeEmail;
    },

    eurToPln: (state) => {
        return state.eurToPln;
    },

    addressTypes: (state) => {
        return state.addressTypes;
    },

    getDefaultCurrencyCode: (state) => {
        return state.defaultCurrencyCode;
    },

    getSetting: (state) => (type) => {
        const key = 'front_msg_' + type + '_' + window.APP.locale;
        if(!state.settings[key]) {
            throw new Error('Message not found for key: ' + key);
        }
        return state.settings[key];
    },
};

const mutations = {};

const actions = {};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
